import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter, Switch } from 'react-router-dom';
import App from './app';
import ErrorPage from './ErrorPage/errorPage';
import LandingPage from './LandingPage/landingPage';
import NoInvitationLandingPage from './NoInvitationLandingPage/noInvitationLandingPage';
import ComboAppPage from './ComboAppPage/comboAppPage';
import LoanApplication from './LoanApplication/loanApplication';
import LoanCustomerInformation from './LoanCustomerInformation/loanCustomerInformation';
import FeatureToggle from './FeatureToggle/feature.toggle';
import Timeout from './timeout';
import TimeoutDispatcher from '../dispatchers/timeout.dispatcher';
import {
  getStep,
  getMarketCode,
  getLandingCode,
  getTimeout,
  isLoading,
  isNoInvitationDialogOpen,
  getOfferPreFilledData
} from '../selectors';
import Notification from "./Notification/notification";
import Loading from "./Loading/loading";
import { MarketCodes } from "../marketCodes";
import { BannerDetails } from "../bannerDetails";
import InterstitialPage from "./InterstitialPage/interstitialPage";
import NoInvitationDialog from './LoanApplication/NoInvitationDialog/noInvitationDialog';
import CoBrandedLandingPage from './CoBrandedLandingPage/coBrandedLandingPage';

import PersonlizeLoan from './LoanCustomize/personlizeloan';
import Congrat from './LoanCustomize/congrat';
import Agreement from './LoanCustomize/agreement';
import LoanCustomize from './LoanCustomize/loancustomize';
import BankDetails from "./AddBankDetails/enterBankDetails";
import BankDetailsConfirm from "./AddBankDetails/enterBankDetailsConfirmPage";
import Dashboard from "../dashboard/Dashboard";
import DeclineOffer from "./DeclineOffer/DeclineOffer";
import DocumentUpload from "./LoanDocumentUpload/documentUpload";
import UnderReview from "./LoanUnderReview/underReview";
import OfferExpired from "./OfferExpired/OfferExpired";
import StepUpAuthentication from './StepupAuthentication/StepUpAuthentication';
import Authlock from './StepupAuthentication/Authlock/Authlock';
import { browserBackEventHandler, isBrowserLocked } from "../utils/browserEventHandler";
import { restrictBrowserBackProcess } from "../actions/crossSellApplicationActions";
import NotAvailable from "./NotAvailable/notAvailable";

const addSlashAndPostfix = (array, postfix) => {
  return array.map((value) => value.endsWith('/') ? value.concat(postfix) : value.concat('/').concat(postfix));
};

const createRouteRegex = (routes) => {
  return `(${routes.join('|')})`;
};
export class AppRoutes extends React.Component {
  componentWillReceiveProps(nextProps) {
    browserBackEventHandler(nextProps, this.props);
  }
  componentDidMount() {
    isBrowserLocked( this.props);
  }

  render() {
    const basePaths = ['/', '/apply', '/clapply/cl/CLLanding.action', '/clapply/landing'];
    return (
      <div id="root">
        <Switch>
          <Route exact path={createRouteRegex(addSlashAndPostfix(basePaths, 'invitation'))} render={() => (
            <NotAvailable/>
          )}
          />
          <Route exact path={createRouteRegex(addSlashAndPostfix(basePaths, 'invitation/american'))} render={() => (
            <NotAvailable/>)}
          />
          <Route exact path={createRouteRegex(addSlashAndPostfix(basePaths, 'decision'))} component={App}/>
          <Route exact path={createRouteRegex(addSlashAndPostfix(basePaths, 'lending'))} render={() => ([
            <FeatureToggle key="toggleOn" featureName="integration_with_lending_tree">
              <ComboAppPage affiliateName={MarketCodes.LENDING_TREE} bannerDetails={BannerDetails.LENDING_TREE}/>
            </FeatureToggle>,
            <FeatureToggle key="toggleOff" featureName="integration_with_lending_tree" showWhenFeatureToggleOff={true}>
              <ErrorPage />
            </FeatureToggle>])}
          />
          <Route exact path={createRouteRegex(addSlashAndPostfix(basePaths, 'ck'))} render={() => ([
            <FeatureToggle key="toggleOn" featureName="integration_with_credit_karma">
              <FeatureToggle key="toggleOn" featureName="cl_show_interstitial_page">
                <InterstitialPage affiliateName={MarketCodes.CREDIT_KARMA} />
              </FeatureToggle>
              <FeatureToggle key="toggleOff" featureName="cl_show_interstitial_page" showWhenFeatureToggleOff={true}>
                <ComboAppPage affiliateName={MarketCodes.CREDIT_KARMA} bannerDetails={BannerDetails.CREDIT_KARMA}/>
              </FeatureToggle>
            </FeatureToggle>,
            <FeatureToggle key="toggleOff" featureName="integration_with_credit_karma" showWhenFeatureToggleOff={true}>
              <ErrorPage />
            </FeatureToggle>])}
          />
          <Route exact path={createRouteRegex(addSlashAndPostfix(basePaths, 'ck/apply'))} render={() => (
            <ComboAppPage affiliateName={MarketCodes.CREDIT_KARMA} bannerDetails={BannerDetails.CREDIT_KARMA}/> )}
          />
          <Route exact path={createRouteRegex(basePaths)} render={() => ([
            <NotAvailable/>])}
          />
          <Route path={createRouteRegex(addSlashAndPostfix(basePaths, 'loan'))} render={({ match }) => (
            <LoanApplication match={match} />
          )}
          />
          <Dashboard {...this.props}>
            <Route exact path="/clapply/action/customizeOffer" component={LoanCustomerInformation}/>
            <Route exact path="/clapply/action/customizeOffer/declineOffer" component={DeclineOffer} />
            <Route exact path="/clapply/action/customizeOffer/loanInformation" component={LoanCustomize}/>
            <Route exact path="/clapply/action/customizeOffer/personlize" render={() => (
              <div className="h-100">
                <PersonlizeLoan />
              </div>
            )}
            />
            <Route exact path="/clapply/action/customizeOffer/congrat" component={Congrat}/>
            <Route exact path="/clapply/action/customizeOffer/agreement" component={Agreement}/>
            <Route exact path="/clapply/action/customizeOffer/addBankDetails" component={BankDetails}/>
            <Route exact path="/clapply/action/customizeOffer/documentUpload" component={DocumentUpload}/>
            <Route exact path="/clapply/action/customizeOffer/underReview" component={UnderReview}/>
            <Route exact path="/clapply/action/customizeOffer/bankDetailsConfirm" component={BankDetailsConfirm}/>
            <Route exact path="/clapply/action/customizeOffer/securityCheck" component={StepUpAuthentication}/>
            <Route exact path="/clapply/action/customizeOffer/authLock" component={Authlock}/>
            <Route exact path="/clapply/action/customizePendingOffer/documentUpload" component={DocumentUpload}/>
            <Route exact path="/clapply/action/customizePendingOffer/underReview" component={UnderReview}/>
            <Route exact path="/clapply/action/customizePendingOffer/confirmBankDetails" component={BankDetailsConfirm}/>
            <Route exact path="/clapply/action/customizePendingOffer/declineOffer" render={()=><DeclineOffer {...this.props} button={false} />} />
            <Route exact path="/clapply/action/customizePendingOffer/offerExpired" component={OfferExpired}/>
            <Route exact path="/clapply/action/customizePendingOffer/agreement" component={Agreement}/>
            <Route exact path="/clapply/action/customizePendingOffer/congrat" component={Congrat}/>
          </Dashboard>
          <Route component={ErrorPage}/>
        </Switch>
        { this.props.isLoading && <Loading/> }
        <Timeout timeout={this.props.timeout} step={this.props.step} dispatcher={new TimeoutDispatcher(this.props.dispatch)} history={this.props.history} marketCode={this.props.marketCode} landingCode={this.props.landingCode} />
        <NoInvitationDialog isOpen={this.props.isNoInvitationDialogOpen}/>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  step: getStep(state),
  timeout: getTimeout(state),
  marketCode: getMarketCode(state),
  landingCode: getLandingCode(state),
  isNoInvitationDialogOpen: isNoInvitationDialogOpen(state),
  isLoading: isLoading(state),
  xsell_data: getOfferPreFilledData(state)
});
const mapDispatchToProps = { restrictBrowserBackProcess: restrictBrowserBackProcess };
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps )(AppRoutes)
);
